var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center my-5",staticStyle:{"width":"100%"}},[_c('img',{attrs:{"src":require("@/assets/images/main/svg/icon_error.svg")}}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm._f("translate")(_vm.title)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }